import Axios from "axios";
import { store } from "../store";
import { Notify } from "../../helpers/notification";

const apiClient = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  timeout: 300000,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("flora_token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (err) => {
    const status = err.response?.data?.status;
    const message = err.response?.data?.message;
    if (message) Notify("danger", message);
    if (status === 420) {
      store.dispatch({ type: "LOGOUT" });
    }
    return Promise.reject(err);
  }
);

export default apiClient;
